import React from 'react';
import { ProjectIcon, TemplateDescription, TemplateDetail, TemplateListItem, TemplateTitle } from '../styles';
import ProjectIconAvatar from '../../../../../../component/projectIconAvatar';
import { ICON_COLORS, PROJECT_ICON_TYPE } from '../../../../../../global/constants';
import { ProjectTemplateModel } from '../../../../../../mobx/models/projectTemplate';
import { getColorIndex } from '../../../../../../helpers/common';

interface Props {
  onClick?: () => void;
  templateDetails: ProjectTemplateModel;
  isActive?: boolean;
}

const TemplateCard: React.FC<Props> = ({ onClick, templateDetails, isActive }) => {
  return (
    <>
      <TemplateListItem role='button' isActive={isActive} onClick={onClick}>
        <ProjectIcon>
          <ProjectIconAvatar
            size={36}
            type={templateDetails?.icon?.type ?? PROJECT_ICON_TYPE.DEFAULT}
            reference={templateDetails?.icon?.reference ?? ''}
            backgroundColor={
              templateDetails?.icon?.color
                ? ICON_COLORS[templateDetails?.icon?.color]
                : ICON_COLORS[getColorIndex(templateDetails?.name)]
            }
            projectName={templateDetails?.name || ''}
            iconSize={20}
            borderRadius='8px'
          />
        </ProjectIcon>
        <TemplateDetail>
          <TemplateTitle>{templateDetails?.name}</TemplateTitle>
          <TemplateDescription>{templateDetails?.description}</TemplateDescription>
        </TemplateDetail>
      </TemplateListItem>
    </>
  );
};

export default TemplateCard;
